
import React, { HTMLAttributes, useEffect, useMemo, useRef, useState } from 'react'
import { formateDate } from 'utils/formatDate'
import { GraphSalesData, HighLightsData, MapFilterData, Region, SalesData, salesFilterData, SalesPeopleData, State, Team } from './salesForecastTypes'
import { Calendar } from 'primereact/calendar'
import { Button } from 'primereact/button'

import { ToggleViewState } from 'pages/forecast/forecastTypes'


import gridViewIconDark from "../../assets/icons/grid-view-icon-dark.svg"
import analyticsIconDark from "../../assets/icons/analytics-icon-dark.svg"

import gridViewIconLight from "../../assets/icons/grid-view-icon-light.svg"
import analyticsIconLight from "../../assets/icons/analytics-icon-light.svg"


import dnIcon from "../../assets/icons/dn-icon.svg"
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect, } from 'primereact/multiselect'

import DefaultGraph from 'components/sales-forecast/Graph/DefaultGraph'
import Grid from 'components/sales-forecast/Table/Grid'
import { useSearchParams } from 'react-router-dom'
import { handleLoader } from 'redux/counterSlice'
import { getAllRegionData, getHighlights, getSalesForecastData, getSalesForecastGraphData, getSalesMapData, getSalesPersonData } from 'services/salesForecastService'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import Card from "components/sales-forecast/Graph/Card"
import { Toast } from 'primereact/toast'




const SalesForecast = () => {

  const countryRef: any = useRef()
  const stateRef: any = useRef()
  const cityRef: any = useRef()
  const salesLeadRef: any = useRef()
  const salesRepRef: any = useRef()

  const calenderRef = useRef<Calendar>(null)
  const cardRef = useRef<HTMLDivElement>(null);
  const toastRef = useRef<Toast>(null);
  const [searchParams] = useSearchParams()

  const [regionList, setRegionList] = useState<Region[]>([])
  const [allCountries, setAllCountries] = useState<string[]>([]);
  const [allStates, setAllStates] = useState<State[]>([]);

  const [cityList, setCityList] = useState<string[]>([]);

 

  const [salesPeopleData, setSalesPeopleData] = useState<SalesPeopleData[]>([])
  const [allSalesLead, setAllSalesLead] = useState<string[]>([])
  const [allSalesRep, setAllSalesRep] = useState<string[]>([])

  //tempStates
  const [tempAllCountries, setTempAllCountries] = useState<string[]>([]);
  const [tempAllStates, setTempAllStates] = useState<State[]>([]);
  const [tempCityList, setTempCityList] = useState<string[]>([]);
  const [tempAllSalesLead, setTempAllSalesLead] = useState<string[]>([])
  const [tempAllSalesRep, setTempAllSalesRep] = useState<string[]>([])





  const [downloadCsv, setDownloadCsv] = useState<boolean>(false)

  const firstForecast: number | null = searchParams.get("first") !== null ? Number(searchParams.get("first")) : 0
  const [first, setFirst] = useState<number>(firstForecast)

  const dispatch = useDispatch()

  const [dates, setDates] = useState<Date[]>(() => {
    const today = new Date();
    // const nextYear = new Date("2025-07-28");
    const nextYear = new Date();
    nextYear.setDate(today.getDate() + 365);
    return [today, nextYear];
  })

  const [salesFilterData, setSalesFilterData] = useState<salesFilterData>({
    client_env: localStorage.getItem("clientName") as string,
    forecast_by: "Week",
    forecast_range_start_date: formateDate(dates[0]),
    forecast_range_end_date: formateDate(dates[1]),
    city_name: [],
    country: [],
    state: [],
    sales_manager: [],
    sales_rep: []


  })

  const [mapFilterData, setMapFilterData] = useState<MapFilterData>({
    client_env: localStorage.getItem("clientName") as string,
    forecast_range_start_date: formateDate(dates[0]),
    forecast_range_end_date: formateDate(dates[1]),
    country: [],
    state: [],
    city_name: [],
    sales_manager: [],
    sales_rep: []
  })

  const [toggleView, setToggleView] = useState<ToggleViewState>({
    chartView: true,
    gridView: false
  });


  const [salesData, setSalesData] = useState<SalesData>()
  const [salesGraphData, setSalesGraphData] = useState<GraphSalesData>()
  const [salesMapData, setSalesMapData] = useState<any>()
  const [highLightsData, setHighLightsData] = useState<HighLightsData>({
    total_next_30_days_forecast: 0,
    percentage_difference: "",
    startDate: "",
    endDate: "",
    total_previous_year_30_days_history: 0,
    total_forecast_quantity: 0,
    total_sales_quantity: 0,
    forcast_percentage: "",
    forecast_arrow: "",
    top_cities: [],
    history_quarters: [],
    forecast_quarters: [],
    top_countries:[],
    top_states: [],


  })
  const foreCastByList = ["Day", "Week", "Month"]



  const handleDateSelection = (e: any) => {
    const selectedDatesArray = e.value
    if (selectedDatesArray?.length === 2) {
      // Update the selected dates when a valid range is selected
      setDates(selectedDatesArray)
      setSalesFilterData({
        ...salesFilterData,
        forecast_range_start_date: formateDate(selectedDatesArray[0]),
        forecast_range_end_date: formateDate(selectedDatesArray[1]),
      })
      setMapFilterData({
        ...mapFilterData,
        forecast_range_start_date: formateDate(selectedDatesArray[0]),
        forecast_range_end_date: formateDate(selectedDatesArray[1]),
      })
    } else {
      // Clear the selection when less than two dates are selected
      setDates([])
    }
  }

  async function handleSubmit(salesFilterData: salesFilterData) {



    try {

      toggleView.gridView && await fetchSalesData(salesFilterData)
      toggleView.chartView && await fetchSalesGraphData(salesFilterData)
      toggleView.chartView && await fetchSalesMapData(mapFilterData)

      dispatch(handleLoader(false))

    } catch (error: any) {
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }
  //api calls

  const fetchSalesData = async (filterSalesData: salesFilterData) => {
    try {
      dispatch(handleLoader(true))
      const { result, error } = await getSalesForecastData(filterSalesData)
      if (error) {
        throw error
      }
      setSalesData(result)

      dispatch(handleLoader(false))
    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }

  const fetchSalesGraphData = async (filter: any) => {

    try {

      dispatch(handleLoader(true))
      //for graph
      const { result, error } = await getSalesForecastGraphData(filter)
      if (error) {
        throw error
      }
 
      setSalesGraphData(result)


    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }

  const fetchSalesMapData = async (filter: MapFilterData) => {

    try {

      const { result, error } = await getSalesMapData(filter)
      if (error) {
        throw error
      }

      setSalesMapData(result.result)
      dispatch(handleLoader(false))
    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }


  const fetchAllCitiesData = async () => {

    try {
      
      const { result, error } = await getAllRegionData()
      if (error) {
        throw error
      }
      setRegionList(result)

      const countries = result.map((country: Region) => country.country_name);
      setAllCountries(countries.sort((a: string, b: string) => a.localeCompare(b)));
      setTempAllCountries(countries.sort((a: string, b: string) => a.localeCompare(b)))

      const states = result.flatMap((country: Region) => country.states);
      setAllStates(states.sort((a: State, b: State) => a.state_name.localeCompare(b.state_name)));
      setTempAllStates(states.sort((a: State, b: State) => a.state_name.localeCompare(b.state_name)))

      const cities = states.flatMap((state: State) => state.cities);

      setCityList(cities.sort((a: string, b: string) => a.localeCompare(b)));
      setTempCityList(cities.sort((a: string, b: string) => a.localeCompare(b)))

    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }


  const fetchSalesPersonData = async () => {

    try {

      const { result, error } = await getSalesPersonData()
      if (error) {
        throw error
      }

      setSalesPeopleData(result)


      const managers: string[] = [];
      const reps: string[] = [];
 

      result.forEach((cityData: SalesPeopleData) => {
        cityData.teams.forEach((team: Team) => {
          // Add team leader (sales manager)
          if (!managers.includes(team.sales_team_leader)) {
            managers.push(team.sales_team_leader);
          }
          // Add sales associates (sales representatives)
          team.sales_associates.forEach(rep => {
            if (!reps.includes(rep)) {
              reps.push(rep);
            }
          });
        });
      });

      setAllSalesLead(managers.sort((a: string, b: string) => a.localeCompare(b)))
      setTempAllSalesLead(managers.sort((a: string, b: string) => a.localeCompare(b)))
      setAllSalesRep(reps.sort((a: string, b: string) => a.localeCompare(b)))
      setTempAllSalesRep(reps.sort((a: string, b: string) => a.localeCompare(b)))


    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }



  const fetchHighlights = async (filter: MapFilterData) => {

    try {

      const { result, error } = await getHighlights(filter)
      if (error) {
        throw error
      }

      // const highLightsData = {
      //   total_next_30_days_forecast: result.total_next_30_days_forecast,
      //   percentage_difference: result.percentage_difference,
      //   startDate: salesFilterData.forecast_range_start_date,
      //   endDate: salesFilterData.forecast_range_end_date,
      //   total_forecast_quantity: result.total_forecast_quantity,
      //   total_sales_quantity: result.total_sales_quantity,
      //   top_cities: result.top_cities,
      //   history_quarters: result.history_quarters,
      //   forecast_quarters: result.forecast_quarters,
      //   top_states: result.top_states,
      //   top_countries: result.top_countries

      // }
      const highLightsData = {...result,  startDate: salesFilterData.forecast_range_start_date,
        endDate: salesFilterData.forecast_range_end_date,}

      setHighLightsData(highLightsData)

    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }

  //other functions

  function toggleForecastView(name: string) {

    if (name === "chart" && toggleView.chartView === false) {




      setToggleView(prev => { return { ...prev, chartView: true, gridView: false } })
      fetchSalesGraphData(salesFilterData)
      fetchSalesMapData(mapFilterData)

    }

    else if (name === "grid" && toggleView.gridView === false) {

      setToggleView(prev => { return { ...prev, gridView: true, chartView: false } })
      // const forGridData = {...salesFilterData, country: [allCountries[0]], state: [allStates[0].state_name], city_name: [], sales_manager: [], sales_rep: []} // send first dat for toggle
      // const forMapData = {...mapFilterData, country: [allCountries[0]], state: [allStates[0].state_name], city_name: []}
      // setSalesFilterData(forGridData)
      // setSalesMapData(forMapData)
     
      fetchSalesData(salesFilterData)
    }

  }


  //lifecycles



  useEffect(() => {

    async function getHomeData() {

      try {
        await fetchSalesGraphData(salesFilterData)
        await fetchAllCitiesData()
        await fetchSalesPersonData()
        await fetchHighlights(mapFilterData)

        await fetchSalesMapData(mapFilterData)
      }
      catch (error) {
        console.error("Error occurred:", error);
      }


    }

    getHomeData()

  }, [])


  useEffect(() => {

    salesGraphData && handleSubmit(salesFilterData) || salesData && handleSubmit(salesFilterData)
  }, [salesFilterData.forecast_by])


  /* templates */
  const regionItemTemplate = (option: any) => {

    return (
      <div className="flex align-items-center">
        <div>{option?.label} </div>
      </div>
    );
  };

  const regionFooterTemplate = (refID:string) => {

    function handleClear() {
    
     setSalesFilterData({ ...salesFilterData, [refID]: [] })

      if (["country", "state", "city_name"].includes(refID)) {
        setMapFilterData({ ...mapFilterData, [refID]: [] });
      }

    }

    return (
      <div className="filter-action-btn">
        <Button label="Clear" className="outline-icon-btn mr-2" onClick={handleClear} />
        <Button label="Apply" className="outline-active-btn" onClick={() => {
          switch(refID){

            case "country": 
            countryRef.current.hide();
            setAllStates(filteredStates);
            const filteredSalesStates = salesFilterData.state.filter(statename =>
              filteredStates.some(state => state.state_name === statename)
            );
            
            setSalesFilterData(prevData => ({
              ...prevData,
              state: filteredSalesStates,
              city_name: [],
              sales_manager: [],
              sales_rep: [],
            }));
            setMapFilterData(prev => ({ ...prev, state: filteredSalesStates, city_name: [] }));
                 
            break;

            case "state": 
            stateRef.current.hide(); 
            setCityList(filteredCities);
            const filteredSalesCities = salesFilterData.city_name.filter(city => filteredCities.includes(city));
            setSalesFilterData(prevData => ({ ...prevData, city_name: filteredSalesCities }));
            setMapFilterData(prev => ({ ...prev, city_name: filteredSalesCities }));
            break;

            case "city_name": 
            cityRef.current.hide(); 
            setAllSalesLead(filteredLeads);
            const filteredSalesLeads = salesFilterData.sales_manager.filter(lead => filteredLeads.includes(lead));
            setSalesFilterData(prevData => ({ ...prevData, sales_manager: filteredSalesLeads }));
            break;

            case "sales_manager": 
            salesLeadRef.current.hide(); 
            setAllSalesRep(filteredReps);
            const filteredSalesReps = salesFilterData.sales_rep.filter(rep => filteredReps.includes(rep));
            setSalesFilterData(prevData => ({ ...prevData, sales_rep: filteredSalesReps }));
            break;

            case "sales_rep": salesRepRef.current.hide();  break;
          }
          //filters handling


          handleSubmit(salesFilterData)
        }} />
      </div>
    );
  }
  const calenderFooterTemplate = () => {
    return (
      <div className="filter-action-btn text-center">
        <Button label="Apply" className="outline-active-btn" onClick={() => {
          calenderRef.current?.hide()
          handleSubmit(salesFilterData)
        }
        } />
      </div>
    );

  }

  //memoize start

  const filteredStates = useMemo(() => {
    const selectedCountry = salesFilterData.country;
    return selectedCountry.length > 0
      ? regionList?.find(country => selectedCountry.includes(country.country_name))?.states ?? []
      : regionList.flatMap(country => country.states);
  }, [salesFilterData.country, regionList]);


  const filteredCities = useMemo(() => {
    const selectedStates = salesFilterData.state;
    return selectedStates.length > 0
      ? allStates
          .filter(state => selectedStates.includes(state.state_name))
          .flatMap(state => state.cities)
      : allStates.flatMap(state => state.cities);
  }, [salesFilterData.state, allStates]);


  const filteredLeads = useMemo(() => {
    const selectedCities = salesFilterData.city_name;
    return selectedCities.length > 0
      ? salesPeopleData
          .filter(cityData => selectedCities.includes(cityData.city))
          .flatMap(cityData => cityData.teams.map(team => team.sales_team_leader))
      : salesPeopleData
          .filter(cityData => cityList.includes(cityData.city))
          .flatMap(cityData => cityData.teams.map(team => team.sales_team_leader));
  }, [salesFilterData.city_name, cityList, salesPeopleData]);


  const filteredReps = useMemo(() => {
    const selectedManagers = salesFilterData.sales_manager;
    return selectedManagers.length > 0
      ? salesPeopleData
          .filter(cityData => cityList.includes(cityData.city))
          .flatMap(cityData =>
            cityData.teams
              .filter(team => selectedManagers.includes(team.sales_team_leader))
              .flatMap(team => team.sales_associates)
          )
      : salesPeopleData
          .filter(cityData => cityList.includes(cityData.city))
          .flatMap(cityData => cityData.teams.flatMap(team => team.sales_associates));
  }, [salesFilterData.sales_manager, cityList, salesPeopleData]);

//temp list handling

useEffect(()=>{
  //tempcitylist
  
    const tempList = allCountries.filter((item) => (salesFilterData.country?.includes(item) && item))

        const newItems = [
          ...tempList,
          ...allCountries.filter((item) => salesFilterData.country && !salesFilterData.country.includes(item)&& item) // Unselected items
        ];
        setTempAllCountries(newItems);
    
    setSalesFilterData({...salesFilterData, state: [], city_name: [], sales_manager: [], sales_rep: []})
    }, [salesFilterData.country])



useEffect(()=>{
  //tempcitylist
  
    const tempList = allStates.filter((item) => (salesFilterData.state?.includes(item.state_name) && item))

        const newItems = [
          ...tempList,
          ...allStates.filter((item) => salesFilterData.state && !salesFilterData.state.includes(item.state_name)&& item) // Unselected items
        ];
        setTempAllStates(newItems);
    
    setSalesFilterData({...salesFilterData, city_name: [], sales_manager: [], sales_rep: []})
    }, [salesFilterData.state])


useEffect(()=>{
//tempcitylist

	const tempList = cityList.filter((item) => (salesFilterData.city_name?.includes(item)))

			const newItems = [
				...tempList,
				...cityList.filter((item) => salesFilterData.city_name && !salesFilterData.city_name.includes(item)) // Unselected items
			];
			setTempCityList(newItems);
	
      setSalesFilterData({...salesFilterData, sales_manager: [], sales_rep: []})
	}, [salesFilterData.city_name])

  useEffect(()=>{
//tempsaleslead

    const tempList = allSalesLead?.filter((item) => (salesFilterData.sales_manager?.includes(item)))

        const newItems = [
          ...tempList,
          ...allSalesLead.filter((item) => salesFilterData.sales_manager && !salesFilterData.sales_manager.includes(item)) // Unselected items
        ];
        setTempAllSalesLead(newItems);
    
        setSalesFilterData({...salesFilterData, sales_rep: []})
    }, [salesFilterData.sales_manager])

    useEffect(()=>{
//tempsalesRep

      const tempList = allSalesRep.filter((item) => (salesFilterData.sales_rep?.includes(item)))

          const newItems = [
            ...tempList,
            ...allSalesRep.filter((item) => salesFilterData.sales_rep && !salesFilterData.sales_rep.includes(item)) // Unselected items
          ];
          setTempAllSalesRep(newItems);
      
      
      }, [salesFilterData.sales_rep])

      const showCityError = () => {
        toastRef.current?.show({ severity: 'info', summary: 'Info', detail: 'Please select atleast one city', life: 2000 });
      }
  return (<>
    <Toast ref={toastRef} />
    <div className='p-4 content-wrapper w-100'>
       <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
        {/* <div className="forest-sub-heading">
            Forecast accuracy<b className="text-green-dark ml-2">{data?.accuracy || graphData?.accuracy}{(data?.accuracy || graphData?.accuracy) && '%'}</b>
          </div> */}
          <h5 className='mb-0 forcast-heading'>Forecast Highlights</h5>
        <div className="flex gap-3">
          <button className="download-btn" onClick={() => setDownloadCsv(true)}>
            <img src={dnIcon} alt="download-icon" />
            Download
          </button>
          <div className="tab-view">
            <span onClick={() => toggleForecastView("chart")} className={toggleView.chartView ? "active" : ""}>
              <img src={toggleView.chartView ? analyticsIconDark : analyticsIconLight} alt="analytics image" />
              Graph
            </span>
            <span onClick={() => toggleForecastView("grid")} className={toggleView.gridView ? "active" : ""}>
              <img src={toggleView.gridView ? gridViewIconDark : gridViewIconLight} alt="grid image" />
              Grid
            </span>
          </div>
        </div>
      </div>
      <Card highLightsData={highLightsData} ref={cardRef} />
      <section className="user-management-section sales-forcast-section">
        <div className="d-flex align-items-center justify-content-between flex-wrap table-top-row mb-4">
          <div className="d-flex justify-content-between align-items-center table-right-row">
            <div className="d-flex align-items-center flex-wrap table-right-first">
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
                <span className="outer-box-label">Country: </span>
                <MultiSelect
                  value={salesFilterData.country}
                  style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                  onChange={(e)=>{ setSalesFilterData({ ...salesFilterData, country: e.value })
                   setMapFilterData({ ...mapFilterData, country: e.value })
                }}
                  filter
                  name={"country"}
                  id={"country"}
                  placeholder="All"
                  options={tempAllCountries.map(country => ({ label: country, value: country }))}
                  itemTemplate={regionItemTemplate}
                  maxSelectedLabels={0}
                  panelFooterTemplate={()=>regionFooterTemplate("country")}
                  resetFilterOnHide={true}
                  className="outline-select multi-select product-select"
                  ref={countryRef}
                  virtualScrollerOptions={{ itemSize: 24, className:"virtual-multi-select"}}
                />
              </div>
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
                <span className="outer-box-label">State: </span>
                <MultiSelect
                  value={salesFilterData.state}
                  style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                  onChange={(e)=> {
                    setSalesFilterData({ ...salesFilterData, state: e.value })
                    setMapFilterData({ ...mapFilterData, state: e.value })
                  }}
                  filter
                  name={"state"}
                  id={"state"}
                  placeholder="All"
                  options={tempAllStates.map(state => ({ label: state.state_name, value: state.state_name }))}
                  maxSelectedLabels={0}
                  itemTemplate={regionItemTemplate}
                  panelFooterTemplate={()=>regionFooterTemplate("state")}
                  resetFilterOnHide={true}
                  className="outline-select multi-select product-select"
                  ref={stateRef}
                  virtualScrollerOptions={{ itemSize: 24, className:"virtual-multi-select"}}
                />
              </div>
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
                <span className="outer-box-label">City: </span>
                <MultiSelect
                  value={salesFilterData.city_name}
                  style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                  onChange={(e)=> {
                    setSalesFilterData({ ...salesFilterData, city_name: e.value }); 
                    setMapFilterData({ ...mapFilterData, city_name: e.value })}}
                  filter
                  name={"city_name"}
                  id={"city_name"}
                  placeholder="All"
                  options={tempCityList.map(city => ({ label: city, value: city }))}
                  maxSelectedLabels={0}
                  itemTemplate={regionItemTemplate}
                  panelFooterTemplate={()=>regionFooterTemplate("city_name")}
                  resetFilterOnHide={true}
                  className="outline-select multi-select product-select"
                  ref={cityRef}
                  virtualScrollerOptions={{ itemSize: 24, className:"virtual-multi-select"}}
                />
              </div>
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border" 
              onClick={()=>salesFilterData.city_name.length === 0 && showCityError()}>
                <span className="outer-box-label">Sales Manager: </span>
                <MultiSelect
                  value={salesFilterData.sales_manager}
                  style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                  onChange={(e)=>{ 
                    setSalesFilterData({ ...salesFilterData, sales_manager: e.value })
                    setMapFilterData({ ...mapFilterData, sales_manager: e.value })
                  }}
                  filter
                  name={"sales_manager"}
                  id={"sales_manager"}
                  placeholder="All"
                  options={tempAllSalesLead?.map(person => ({ label: person, value: person }))}
                  maxSelectedLabels={0}
                  itemTemplate={regionItemTemplate}
                  panelFooterTemplate={()=>regionFooterTemplate("sales_manager")}
                  resetFilterOnHide={true}
                  className="outline-select multi-select product-select"
                  ref={salesLeadRef}
                  virtualScrollerOptions={{ itemSize: 24, className:"virtual-multi-select"}}
                  disabled={salesFilterData.city_name.length > 0 ? false: true}
                />
              </div>
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border"
              onClick={()=>salesFilterData.city_name.length === 0 && showCityError()}>
                <span className="outer-box-label">Sales Rep: </span>
                <MultiSelect
                  value={salesFilterData.sales_rep}
                  style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                  onChange={(e) => {
                    setSalesFilterData({ ...salesFilterData, sales_rep: e.value })
                    setMapFilterData({ ...mapFilterData, sales_rep: e.value })
                  }
                  }
                  filter
                  name={"sales_rep"}
                  id={"sales_rep"}
                  placeholder="All"
                  options={tempAllSalesRep?.map(person => ({ label: person, value: person }))}
                  maxSelectedLabels={0}
                  itemTemplate={regionItemTemplate}
                  panelFooterTemplate={()=>regionFooterTemplate("sales_rep")}
                  resetFilterOnHide={true}
                  className="outline-select multi-select product-select"
                  ref={salesRepRef}
                  virtualScrollerOptions={{ itemSize: 24, className:"virtual-multi-select"}}
                  disabled={salesFilterData.city_name.length > 0 ? false: true}
                />
              </div>
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
                <span className="outer-box-label">Forecast by: </span>
                <Dropdown
                  value={salesFilterData?.forecast_by}
                  style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                  onChange={(e) => {
                    setSalesFilterData({ ...salesFilterData, forecast_by: e.value })

                  }}
                  name="forecastBy"
                  id="forecastBy"
                  options={foreCastByList}
                  placeholder="Select an interval"
                  className="outline-select multi-select"
                />
              </div>
              <div className="d-flex align-items-center mr-3 mt-1 mb-1 voice-filter-col filter-calendar">
                <Calendar
                  minDate={new Date()}
                  name="duration"
                  value={dates}
                  onChange={handleDateSelection}
                  selectionMode="range"
                  showIcon
                  readOnlyInput

                  dateFormat="dd/mm/yy"
                  view="date"
                  footerTemplate={calenderFooterTemplate}
                  ref={calenderRef}
                />
              </div>
              {/* <Button type="button" className="outline-btn">Submit</Button>             */}
            </div>
          </div>
        </div>
      </section>
      {(toggleView.chartView) ?
        ((salesGraphData && salesMapData) &&
          <DefaultGraph graphData={salesGraphData} salesFilterData={salesFilterData} salesMapData={salesMapData} downloadCsv={downloadCsv}
            setDownloadCsv={setDownloadCsv} currentUIView={toggleView}
            mapFilterData={mapFilterData} cardRef={cardRef} setToggleView={setToggleView} fetchSalesData={fetchSalesData}
            setSalesFilterData={setSalesFilterData} setMapFilterData={setMapFilterData}/>
            
          )

        : (salesData && <div className="datatable-wrapper">
          <Grid
            first={first}
            setFirst={setFirst}
            setSalesFilter={setSalesFilterData}
            data={salesData}
            salesFilterData={salesFilterData}
            downloadCsv={downloadCsv}
            setDownloadCsv={setDownloadCsv}
            currentUIView={toggleView}

          />
        </div>
        )
        // )
      }
    </div>
    </>
  )
}

export default SalesForecast

